<div class="view-background-color w-full h-full ">
  <app-create-ticket-component [props]="childProps"></app-create-ticket-component>
</div>
